import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthProvider";

export default function PrivateRoute({ children }) {
  const { ready, authenticated } = useContext(AuthContext);

  if (!ready) return null;
  if (!authenticated) return <Navigate to="/" replace />;
  return children;
}
